import { SiteFooter } from '../../../shared/ui/SiteFooter.jsx';
import { SiteSupportBoard } from './UnionSupportBoard.jsx';

export function StandaloneSiteSupport({ mobile = false, onClose }) {
  return (
    <div className={`site-support-standalone ${mobile ? 'mobile' : 'desktop'}`.trim()}>
      <header className="site-support-standalone-header">
        <div><p>DOROPARTY SUPPORT</p><h1>사이트 문의</h1><span>유니온 가입 상태와 관계없이 DoroParty 이용 문의를 등록할 수 있습니다.</span></div>
        <button type="button" onClick={onClose}>돌아가기</button>
      </header>
      <main className="site-support-standalone-main"><SiteSupportBoard mobile={mobile} /></main>
      <SiteFooter compact={mobile} />
    </div>
  );
}
